export const VIEWABLE_FILE_TYPES = ["jpeg", "jpg", "pdf", "png", "txt"];